var PLASMA_STREAM_YKR_K_002E = {
	name: "PLASMA STREAM YKR K 002E",
	defaultCommandIndex: 1,
	commands: [
		{
			mode: "AC_MODE_OFF",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_NULL",
			command: [211,0,4,106,2,228,1,91,2,119,6,151,35,102,17,81,2,0,0,43,234,174,191,171,255,246,255,253,255,255,255,255,219,245,93,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,156,2,178,1,154,2,57,6,230,35,34,17,146,2,0,0,43,234,175,127,87,255,237,255,251,255,255,253,255,223,235,117],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,150,2,175,1,156,2,59,6,224,35,1,17,145,2,0,0,43,234,171,191,171,255,246,255,253,255,255,254,255,255,247,106],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,151,2,173,1,154,2,58,6,231,35,33,17,149,2,0,0,43,234,173,191,171,255,246,255,253,255,255,254,255,255,246,181],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,158,2,179,1,150,2,58,6,246,35,35,17,148,2,0,0,43,234,170,223,213,255,251,127,254,255,255,255,127,255,251,213],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,155,2,167,1,157,2,55,6,178,35,75,17,150,2,0,0,43,234,174,191,171,255,246,255,253,255,255,254,255,255,246,213],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,163,2,176,1,150,2,57,6,228,35,46,17,149,2,0,0,43,234,171,95,213,255,251,127,254,255,255,255,127,255,251,170,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,153,2,177,1,141,2,63,6,157,35,103,17,143,2,0,0,43,234,173,95,213,255,251,127,254,255,255,255,127,255,251,85,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,166,2,171,1,168,2,56,6,204,35,63,17,171,2,0,0,43,234,170,175,234,255,253,191,255,127,255,255,191,255,253,252],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,165,2,176,1,168,2,56,6,164,35,107,17,165,2,0,0,43,234,175,191,87,255,237,255,251,255,255,253,255,255,237,240],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,160,2,172,1,166,2,58,6,249,35,50,17,174,2,0,0,43,234,171,223,171,255,246,255,253,255,255,254,255,255,247,120],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,145,2,193,1,137,2,77,6,163,35,113,17,149,2,0,0,43,234,173,223,171,255,246,255,253,255,255,254,255,255,246,188],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,151,2,184,1,161,2,57,6,182,35,105,17,154,2,0,0,43,234,170,239,213,255,251,127,254,255,255,255,127,255,251,220],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,160,2,170,1,165,2,57,6,201,35,63,17,171,2,0,0,43,234,174,223,171,255,246,255,253,255,255,254,255,255,246,220],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,162,2,169,1,158,2,57,6,208,35,55,17,174,2,0,0,43,234,171,111,213,255,251,127,254,255,255,255,127,255,251,174],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,143,2,205,1,157,2,43,6,193,35,78,17,113,2,0,0,43,234,173,111,213,255,251,127,254,255,255,255,127,255,251,87],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,157,2,171,1,168,2,55,6,178,35,95,17,177,2,0,0,43,234,170,183,234,255,253,191,255,127,255,255,191,255,253,246],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,151,2,175,1,163,2,60,6,225,35,35,17,165,2,0,0,43,234,175,95,171,255,246,255,253,255,255,254,255,255,246,236],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [211,0,4,123,2,217,1,122,2,97,6,172,35,114,17,101,2,0,0,43,234,175,127,87,255,235,255,251,255,255,253,255,223,235,122],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [211,0,4,163,2,168,1,169,2,54,6,204,35,59,17,150,2,0,0,43,234,171,191,171,255,245,255,253,255,255,254,255,239,245,221],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [211,0,4,161,2,171,1,163,2,56,6,178,35,53,17,150,2,0,0,43,234,173,191,171,255,245,255,253,255,255,254,255,239,245,174,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [211,0,4,158,2,173,1,164,2,53,6,202,35,82,17,154,2,0,0,43,234,170,223,213,255,250,255,254,255,255,255,127,247,250,246,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [211,0,4,154,2,200,1,107,2,85,6,165,35,155,17,151,2,0,0,43,234,174,191,171,255,245,255,253,255,255,254,255,239,245,182,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [211,0,4,153,2,174,1,164,2,59,6,211,35,77,17,151,2,0,0,43,234,171,95,213,255,250,255,254,255,255,255,127,247,250,235,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [211,0,4,149,2,177,1,158,2,59,6,159,35,101,17,141,2,0,0,43,234,173,95,213,255,250,255,254,255,255,255,127,247,250,213,160],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [211,0,4,168,2,171,1,159,2,55,6,204,35,43,17,149,2,0,0,43,234,170,175,234,255,253,127,255,127,255,255,191,251,253,125,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [211,0,4,158,2,176,1,154,2,58,6,238,35,39,17,149,2,0,0,43,234,175,191,87,255,235,255,251,255,255,253,255,223,235,117],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [211,0,4,154,2,171,1,159,2,57,6,222,35,45,17,148,2,0,0,43,234,171,223,171,255,245,255,253,255,255,254,255,239,245,218,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [211,0,4,152,2,174,1,155,2,57,6,168,35,105,17,145,2,0,0,43,234,173,223,171,255,245,255,253,255,255,254,255,239,245,173,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [211,0,4,164,2,173,1,150,2,59,6,163,35,106,17,148,2,0,0,43,234,170,239,213,255,250,255,254,255,255,255,127,247,250,245,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [211,0,4,155,2,172,1,154,2,55,6,183,35,89,17,152,2,0,0,43,234,174,223,171,255,245,255,253,255,255,254,255,239,245,181,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [211,0,4,138,2,199,1,111,2,96,6,167,35,102,17,106,2,0,0,43,234,171,111,213,255,250,255,254,255,255,255,127,247,250,234,160],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [211,0,4,159,2,172,1,150,2,57,6,183,35,97,17,149,2,0,0,43,234,173,111,213,255,250,255,254,255,255,255,127,247,250,213,80],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_LOW",
			command: [211,0,4,166,2,170,1,158,2,57,6,211,35,61,17,177,2,0,0,43,234,170,183,234,255,253,127,255,127,255,255,191,251,253,127],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_LOW",
			command: [211,0,4,167,2,171,1,167,2,56,6,178,35,89,17,171,2,0,0,43,234,175,95,171,255,245,255,253,255,255,254,255,255,246,248],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [211,0,4,163,2,195,1,144,2,55,6,136,35,110,17,96,2,0,0,43,234,175,127,87,255,247,255,247,255,255,251,255,191,214,214],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [211,0,4,152,2,176,1,153,2,57,6,200,35,104,17,168,2,0,0,43,234,171,191,171,255,251,255,251,255,255,253,255,255,238,172],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [211,0,4,171,2,184,1,164,2,37,6,197,35,109,17,99,2,0,0,43,234,173,191,175,255,239,255,239,255,255,247,255,255,181,88],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [211,0,4,119,2,218,1,127,2,79,6,165,35,105,17,171,2,0,0,43,234,170,223,213,255,253,255,253,255,255,254,255,255,247,232],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [211,0,4,164,2,175,1,164,2,59,6,237,35,21,17,149,2,0,0,43,234,174,191,171,255,251,255,251,255,255,253,255,255,237,232],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [211,0,4,159,2,173,1,170,2,55,6,164,35,97,17,139,2,0,0,43,234,171,95,213,255,253,255,253,255,255,254,255,255,247,116],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [211,0,4,163,2,171,1,164,2,57,6,188,35,79,17,150,2,0,0,43,234,173,95,213,255,253,255,253,255,255,254,255,255,246,186],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [211,0,4,157,2,167,1,170,2,57,6,212,35,62,17,149,2,0,0,43,234,170,175,234,255,254,255,254,255,255,255,127,255,251,218],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [211,0,4,130,2,192,1,165,2,60,6,168,35,106,17,126,2,0,0,43,234,175,191,87,255,247,255,247,255,255,251,255,255,219,104],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [211,0,4,156,2,171,1,163,2,56,6,212,35,79,17,151,2,0,0,43,234,171,223,171,255,251,255,251,255,255,253,255,255,238,180],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [211,0,4,154,2,170,1,161,2,56,6,190,35,84,17,149,2,0,0,43,234,173,223,171,255,251,255,251,255,255,253,255,255,237,90],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [211,0,4,158,2,181,1,144,2,68,6,165,35,101,17,128,2,0,0,43,234,170,239,213,255,253,255,253,255,255,254,255,255,247,212],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [211,0,4,162,2,175,1,155,2,55,6,170,35,97,17,155,2,0,0,43,234,174,223,171,255,251,255,251,255,255,253,255,255,237,212],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [211,0,4,161,2,169,1,160,2,54,6,190,35,48,17,151,2,0,0,43,234,171,111,213,255,253,255,253,255,255,254,255,255,247,106],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [211,0,4,115,2,213,1,119,2,89,6,167,35,111,17,111,2,0,0,43,234,173,111,213,255,253,255,253,255,255,254,255,255,246,181],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_MID",
			command: [211,0,4,166,2,172,1,155,2,55,6,177,35,94,17,151,2,0,0,43,234,170,183,234,255,254,255,254,255,255,255,127,255,251,213],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_MID",
			command: [211,0,4,154,2,175,1,152,2,56,6,214,35,54,17,152,2,0,0,43,234,175,95,171,255,251,255,251,255,255,253,255,255,237,170],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,107,2,220,1,125,2,96,6,166,35,108,17,128,2,0,0,43,234,175,127,87,255,239,255,247,255,255,251,255,191,214,236],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,149,2,176,1,166,2,55,6,177,35,98,17,171,2,0,0,43,234,171,191,171,255,247,255,251,255,255,253,255,223,235,182],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,141,2,185,1,156,2,59,6,190,35,103,17,167,2,0,0,43,234,173,191,171,255,247,255,251,255,255,253,255,223,235,91],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,139,2,188,1,136,2,75,6,163,35,103,17,171,2,0,0,43,234,170,223,213,255,251,255,253,255,255,254,255,239,245,235],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,126,2,201,1,136,2,76,6,166,35,111,17,159,2,0,0,43,234,174,191,171,255,247,255,251,255,255,253,255,223,235,107],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,157,2,172,1,153,2,57,6,208,35,67,17,165,2,0,0,43,234,171,95,213,255,251,255,253,255,255,254,255,239,245,213,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,155,2,168,1,152,2,54,6,183,35,90,17,172,2,0,0,43,234,173,95,213,255,251,255,253,255,255,254,255,239,245,170,192],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,163,2,177,1,157,2,62,6,164,35,109,17,140,2,0,0,43,234,170,175,234,255,253,255,254,255,255,255,127,247,250,253],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,167,2,173,1,164,2,56,6,180,35,98,17,150,2,0,0,43,234,175,191,87,255,239,255,247,255,255,251,255,191,214,244],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,115,2,218,1,122,2,100,6,198,35,103,17,99,2,0,0,43,234,171,223,171,255,247,255,251,255,255,253,255,223,235,186],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,165,2,171,1,162,2,56,6,185,35,85,17,147,2,0,0,43,234,173,223,171,255,247,255,251,255,255,253,255,223,235,93],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,157,2,174,1,162,2,57,6,183,35,85,17,151,2,0,0,43,234,170,239,213,255,251,255,253,255,255,254,255,239,245,237],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,151,2,175,1,166,2,55,6,160,35,101,17,149,2,0,0,43,234,174,223,171,255,247,255,251,255,255,253,255,223,235,109],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,145,2,188,1,153,2,62,6,163,35,102,17,129,2,0,0,43,234,171,111,213,255,251,255,253,255,255,254,255,239,245,214,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,139,2,195,1,150,2,64,6,169,35,113,17,131,2,0,0,43,234,173,111,213,255,251,255,253,255,255,254,255,239,245,171,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,165,2,175,1,155,2,57,6,178,35,91,17,150,2,0,0,43,234,170,183,234,255,253,255,254,255,255,255,127,247,250,250,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,147,2,189,1,140,2,73,6,159,35,110,17,123,2,0,0,43,234,175,95,171,255,247,255,251,255,255,253,255,255,237,212],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,159,2,174,1,154,2,55,6,176,35,105,17,168,2,0,0,43,234,175,127,87,255,237,255,254,255,255,250,255,239,245,171,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,159,2,171,1,168,2,54,6,177,35,96,17,170,2,0,0,43,234,171,191,171,255,246,255,255,127,255,253,127,255,251,236],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,156,2,172,1,166,2,55,6,181,35,86,17,169,2,0,0,43,234,173,191,171,255,246,255,255,127,255,253,127,255,251,118],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,152,2,172,1,166,2,55,6,178,35,109,17,174,2,0,0,43,234,170,223,213,255,251,127,255,191,255,254,191,255,253,219],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,152,2,171,1,161,2,57,6,183,35,87,17,167,2,0,0,43,234,174,191,171,255,246,255,255,127,255,253,127,255,251,91],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,145,2,185,1,152,2,61,6,191,35,101,17,168,2,0,0,43,234,171,95,213,255,251,127,255,191,255,254,191,255,253,235],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,151,2,172,1,158,2,58,6,214,35,55,17,165,2,0,0,43,234,173,95,213,255,251,127,255,191,255,254,191,255,253,181,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,102,2,223,1,100,2,109,6,171,35,101,17,130,2,0,0,43,234,170,175,234,255,253,191,255,223,255,255,95,255,254,234,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,153,2,168,1,151,2,54,6,168,35,47,17,173,2,0,0,43,234,175,191,87,255,237,255,254,255,255,250,255,255,246,171],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,166,2,172,1,164,2,54,6,177,35,86,17,148,2,0,0,43,234,171,223,171,255,246,255,255,127,255,253,127,255,251,244],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,148,2,188,1,146,2,74,6,156,35,104,17,124,2,0,0,43,234,173,223,171,255,246,255,255,127,255,253,127,255,251,122],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,161,2,170,1,167,2,55,6,207,35,54,17,148,2,0,0,43,234,170,239,213,255,251,127,255,191,255,254,191,255,253,221],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,160,2,174,1,160,2,54,6,185,35,92,17,149,2,0,0,43,234,174,223,171,255,246,255,255,127,255,253,127,255,251,93],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,151,2,175,1,166,2,55,6,157,35,68,17,146,2,0,0,43,234,171,111,213,255,251,127,255,191,255,254,191,255,253,237],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,149,2,174,1,163,2,59,6,220,35,38,17,145,2,0,0,43,234,173,111,213,255,251,127,255,191,255,254,191,255,253,182,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,124,2,209,1,137,2,77,6,169,35,105,17,106,2,0,0,43,234,170,183,234,255,253,191,255,223,255,255,95,255,254,235,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,124,2,203,1,140,2,72,6,172,35,97,17,119,2,0,0,43,234,175,95,171,255,246,255,255,127,255,253,127,255,251,86,128],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [211,0,4,159,2,170,1,151,2,54,6,211,35,49,17,148,2,0,0,43,234,175,127,87,255,235,255,254,255,255,250,255,239,245,170,160],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [211,0,4,166,2,175,1,155,2,55,6,202,35,59,17,163,2,0,0,43,234,171,191,171,255,245,255,255,127,255,253,127,247,250,254],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [211,0,4,168,2,172,1,162,2,54,6,185,35,80,17,164,2,0,0,43,234,173,191,171,255,245,255,255,127,255,253,127,247,250,223],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [211,0,4,163,2,172,1,160,2,56,6,223,35,30,17,167,2,0,0,43,234,170,223,213,255,250,255,255,191,255,254,191,251,253,119,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [211,0,4,164,2,175,1,154,2,53,6,225,35,38,17,162,2,0,0,43,234,174,191,171,255,245,255,255,127,255,253,127,247,250,215,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [211,0,4,165,2,171,1,162,2,54,6,200,35,58,17,165,2,0,0,43,234,171,95,213,255,250,255,255,191,255,254,191,251,253,123,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [211,0,4,154,2,175,1,159,2,57,6,247,35,30,17,165,2,0,0,43,234,173,95,213,255,250,255,255,191,255,254,191,251,253,109,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [211,0,4,156,2,177,1,152,2,55,6,223,35,35,17,162,2,0,0,43,234,170,175,234,255,253,127,255,223,255,255,95,253,254,186,224],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [211,0,4,159,2,174,1,151,2,56,6,220,35,25,17,165,2,0,0,43,234,175,191,87,255,235,255,254,255,255,250,255,239,245,171,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [211,0,4,157,2,177,1,156,2,57,6,154,35,101,17,166,2,0,0,43,234,171,223,171,255,245,255,255,127,255,253,127,247,250,251],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [211,0,4,153,2,174,1,163,2,54,6,145,35,100,17,167,2,0,0,43,234,173,223,171,255,245,255,255,127,255,253,127,247,250,221,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [211,0,4,150,2,175,1,164,2,52,6,162,35,90,17,165,2,0,0,43,234,170,239,213,255,250,255,255,191,255,254,191,251,253,118,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [211,0,4,147,2,178,1,162,2,56,6,182,35,109,17,166,2,0,0,43,234,174,223,171,255,245,255,255,127,255,253,127,247,250,214,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [211,0,4,146,2,183,1,151,2,59,6,150,35,101,17,168,2,0,0,43,234,171,111,213,255,250,255,255,191,255,254,191,251,253,122,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [211,0,4,131,2,195,1,143,2,69,6,156,35,104,17,156,2,0,0,43,234,173,111,213,255,250,255,255,191,255,254,191,251,253,109,96],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_LOW",
			command: [211,0,4,121,2,222,1,134,2,65,6,152,35,163,17,111,2,0,0,43,234,170,183,234,255,253,127,255,223,255,255,95,253,254,186,176],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_LOW",
			command: [211,0,4,104,2,221,1,101,2,103,6,152,35,97,17,137,2,0,0,43,234,175,95,171,255,245,255,255,127,255,253,127,255,251,85,128],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [211,0,4,142,2,185,1,143,2,66,6,215,35,42,17,138,2,0,0,43,234,175,127,87,255,247,255,253,255,255,245,255,223,235,90,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [211,0,4,162,2,177,1,152,2,55,6,236,35,50,17,149,2,0,0,43,234,171,191,171,255,251,255,254,255,255,250,255,255,247,170],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [211,0,4,154,2,172,1,153,2,54,6,195,35,66,17,148,2,0,0,43,234,173,191,171,255,251,255,254,255,255,250,255,255,246,213],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [211,0,4,158,2,179,1,148,2,56,6,197,35,55,17,149,2,0,0,43,234,170,223,213,255,253,255,255,127,255,253,127,255,251,170,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [211,0,4,125,2,204,1,107,2,97,6,156,35,98,17,105,2,0,0,43,234,174,191,171,255,251,255,254,255,255,250,255,255,246,170,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [211,0,4,169,2,174,1,162,2,53,6,178,35,84,17,164,2,0,0,43,234,171,95,213,255,253,255,255,127,255,253,127,255,251,248],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [211,0,4,151,2,187,1,152,2,69,6,224,35,40,17,151,2,0,0,43,234,173,95,213,255,253,255,255,127,255,253,127,255,251,124],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [211,0,4,165,2,174,1,163,2,51,6,151,35,107,17,168,2,0,0,43,234,170,175,234,255,254,255,255,191,255,254,191,255,253,222],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [211,0,4,159,2,176,1,152,2,59,6,221,35,27,17,169,2,0,0,43,234,175,191,87,255,247,255,253,255,255,245,255,255,237,120],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [211,0,4,164,2,173,1,164,2,54,6,172,35,84,17,169,2,0,0,43,234,171,223,171,255,251,255,254,255,255,250,255,255,247,184],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [211,0,4,159,2,172,1,164,2,56,6,210,35,55,17,168,2,0,0,43,234,173,223,171,255,251,255,254,255,255,250,255,255,246,220],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [211,0,4,156,2,180,1,151,2,61,6,227,35,28,17,156,2,0,0,43,234,170,239,213,255,253,255,255,127,255,253,127,255,251,174],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [211,0,4,154,2,177,1,150,2,57,6,220,35,35,17,165,2,0,0,43,234,174,223,171,255,251,255,254,255,255,250,255,255,246,174],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [211,0,4,156,2,175,1,164,2,55,6,178,35,79,17,160,2,0,0,43,234,171,111,213,255,253,255,255,127,255,253,127,255,251,236],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [211,0,4,151,2,178,1,158,2,61,6,247,35,30,17,160,2,0,0,43,234,173,111,213,255,253,255,255,127,255,253,127,255,251,118],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_MID",
			command: [211,0,4,149,2,172,1,162,2,58,6,215,35,42,17,165,2,0,0,43,234,170,183,234,255,254,255,255,191,255,254,191,255,253,219],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_MID",
			command: [211,0,4,150,2,168,1,161,2,58,6,222,35,35,17,171,2,0,0,43,234,175,95,171,255,251,255,254,255,255,250,255,255,246,182],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,153,2,171,1,163,2,53,6,173,35,79,17,151,2,0,0,43,234,175,127,87,255,239,255,253,255,255,245,255,223,235,86,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,165,2,172,1,155,2,55,6,196,35,80,17,150,2,0,0,43,234,171,191,171,255,247,255,254,255,255,250,255,239,245,245],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,162,2,172,1,156,2,57,6,214,35,60,17,152,2,0,0,43,234,173,191,171,255,247,255,254,255,255,250,255,239,245,186,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,117,2,211,1,121,2,91,6,175,35,102,17,107,2,0,0,43,234,170,223,213,255,251,255,255,127,255,253,127,247,250,237,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,150,2,175,1,152,2,58,6,225,35,19,17,146,2,0,0,43,234,174,191,171,255,247,255,254,255,255,250,255,239,245,173,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,166,2,174,1,152,2,54,6,164,35,106,17,147,2,0,0,43,234,171,95,213,255,251,255,255,127,255,253,127,247,250,245,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,150,2,174,1,149,2,58,6,162,35,102,17,145,2,0,0,43,234,173,95,213,255,251,255,255,127,255,253,127,247,250,218,160],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,150,2,185,1,129,2,78,6,179,35,109,17,125,2,0,0,43,234,170,175,234,255,253,255,255,191,255,254,191,251,253,117,80],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,139,2,193,1,126,2,78,6,185,35,112,17,122,2,0,0,43,234,175,191,87,255,239,255,253,255,255,245,255,223,235,85,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,168,2,175,1,150,2,62,6,169,35,96,17,166,2,0,0,43,234,171,223,171,255,247,255,254,255,255,250,255,239,245,252],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,162,2,178,1,158,2,58,6,149,35,101,17,166,2,0,0,43,234,173,223,171,255,247,255,254,255,255,250,255,239,245,190],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,160,2,176,1,158,2,58,6,225,35,30,17,166,2,0,0,43,234,170,239,213,255,251,255,255,127,255,253,127,247,250,239],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,162,2,175,1,155,2,54,6,211,35,53,17,168,2,0,0,43,234,174,223,171,255,247,255,254,255,255,250,255,239,245,175],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,163,2,172,1,164,2,55,6,171,35,84,17,170,2,0,0,43,234,171,111,213,255,251,255,255,127,255,253,127,247,250,247],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,156,2,177,1,160,2,60,6,228,35,36,17,161,2,0,0,43,234,173,111,213,255,251,255,255,127,255,253,127,247,250,219,128],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,157,2,176,1,150,2,60,6,222,35,38,17,164,2,0,0,43,234,170,183,234,255,253,255,255,191,255,254,191,251,253,117,192],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,162,2,167,1,152,2,54,6,181,35,100,17,180,2,0,0,43,234,175,95,171,255,247,255,254,255,255,250,255,255,246,174],
		},
		/////////////////////////////AUTO////////////////////////////
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,152,2,171,1,154,2,54,6,197,35,59,17,171,2,0,0,43,234,175,254,175,255,219,255,255,255,255,247,255,223,213,172],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_LOW",
			command: [211,0,4,138,2,197,1,140,2,76,6,161,35,103,17,144,2,0,0,43,234,175,254,175,255,215,255,255,255,255,247,255,223,213,184],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_MID",
			command: [211,0,4,118,2,220,1,119,2,86,6,65,35,98,17,121,2,0,0,43,234,175,254,175,255,239,255,255,255,255,239,255,191,171,224],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,154,2,175,1,149,2,57,6,212,35,45,17,148,2,0,0,43,234,175,254,175,255,223,255,255,255,255,239,255,191,171,84],
		},
		/////////////////////////////FAN///////////////////////////////
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_LOW",
			command: [211,0,4,151,2,179,1,145,2,63,6,233,35,35,17,140,2,0,0,43,234,175,254,175,255,215,255,250,255,255,253,255,247,245,106,128],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_MID",
			command: [211,0,4,166,2,173,1,155,2,55,6,183,35,82,17,149,2,0,0,43,234,175,254,175,255,239,255,245,255,255,251,255,239,234,234],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,146,2,176,1,168,2,49,6,159,35,103,17,158,2,0,0,43,234,175,254,175,255,223,255,245,255,255,251,255,239,234,218],
		},
		////////////////////////////DRY////////////////////////////////
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,149,2,174,1,149,2,58,6,225,35,31,17,145,2,0,0,43,234,175,127,87,255,237,255,253,255,255,253,255,223,235,106,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,160,2,178,1,149,2,57,6,221,35,36,17,147,2,0,0,43,234,171,191,171,255,246,255,254,255,255,254,255,255,247,85],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,157,2,168,1,149,2,56,6,225,35,35,17,149,2,0,0,43,234,173,191,171,255,246,255,254,255,255,254,255,255,246,170,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,165,2,172,1,164,2,59,6,239,35,42,17,169,2,0,0,43,234,170,223,213,255,251,127,255,127,255,255,127,255,251,248],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,162,2,177,1,161,2,60,6,249,35,34,17,160,2,0,0,43,234,174,191,171,255,246,255,254,255,255,254,255,255,246,248],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,163,2,177,1,157,2,61,6,229,35,40,17,159,2,0,0,43,234,171,95,213,255,251,127,255,127,255,255,127,255,251,188],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,161,2,177,1,155,2,56,6,216,35,40,17,161,2,0,0,43,234,173,95,213,255,251,127,255,127,255,255,127,255,251,94],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,163,2,175,1,166,2,54,6,166,35,96,17,165,2,0,0,43,234,170,175,234,255,253,191,255,191,255,255,191,255,253,238],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,158,2,171,1,170,2,52,6,192,35,105,17,174,2,0,0,43,234,175,191,87,255,237,255,253,255,255,253,255,255,237,184],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,156,2,176,1,159,2,57,6,211,35,58,17,167,2,0,0,43,234,171,223,171,255,246,255,254,255,255,254,255,255,247,92],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,157,2,173,1,154,2,54,6,177,35,81,17,169,2,0,0,43,234,173,223,171,255,246,255,254,255,255,254,255,255,246,174],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,153,2,172,1,159,2,61,6,229,35,37,17,170,2,0,0,43,234,170,239,213,255,251,127,255,127,255,255,127,255,251,236],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,148,2,174,1,163,2,63,6,219,35,33,17,165,2,0,0,43,234,174,223,171,255,246,255,254,255,255,254,255,255,246,236],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,152,2,172,1,167,2,56,6,200,35,60,17,164,2,0,0,43,234,171,111,213,255,251,127,255,127,255,255,127,255,251,182],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,150,2,175,1,157,2,59,6,216,35,39,17,162,2,0,0,43,234,173,111,213,255,251,127,255,127,255,255,127,255,251,91],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,155,2,178,1,155,2,57,6,218,35,46,17,159,2,0,0,43,234,170,183,234,255,253,191,255,191,255,255,191,255,253,235],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_AUTO",
			command: [211,0,4,152,2,171,1,157,2,54,6,175,35,83,17,169,2,0,0,43,234,175,95,171,255,246,255,254,255,255,254,255,255,246,214],
		},
		//////////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [211,0,4,143,2,176,1,162,2,64,6,220,35,36,17,141,2,0,0,43,234,175,127,87,255,235,255,253,255,255,253,255,223,235,109],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [211,0,4,150,2,179,1,154,2,61,6,219,35,41,17,143,2,0,0,43,234,171,191,171,255,245,255,254,255,255,254,255,239,245,214,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [211,0,4,153,2,172,1,159,2,55,6,201,35,61,17,151,2,0,0,43,234,173,191,171,255,245,255,254,255,255,254,255,239,245,171,64],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [211,0,4,157,2,180,1,150,2,62,6,229,35,30,17,144,2,0,0,43,234,170,223,213,255,250,255,255,127,255,255,127,247,250,250,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [211,0,4,162,2,166,1,159,2,54,6,197,35,64,17,148,2,0,0,43,234,174,191,171,255,245,255,254,255,255,254,255,239,245,186,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [211,0,4,154,2,173,1,156,2,56,6,220,35,37,17,149,2,0,0,43,234,171,95,213,255,250,255,255,127,255,255,127,247,250,237,64],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [211,0,4,151,2,176,1,151,2,57,6,222,35,31,17,150,2,0,0,43,234,173,95,213,255,250,255,255,127,255,255,127,247,250,214,160],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [211,0,4,168,2,171,1,153,2,53,6,172,35,85,17,148,2,0,0,43,234,170,175,234,255,253,127,255,191,255,255,191,251,253,122,160],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [211,0,4,146,2,175,1,147,2,61,6,157,35,96,17,135,2,0,0,43,234,175,191,87,255,235,255,253,255,255,253,255,223,235,106,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [211,0,4,163,2,174,1,155,2,52,6,163,35,63,17,148,2,0,0,43,234,171,223,171,255,245,255,254,255,255,254,255,239,245,213,64],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [211,0,4,155,2,176,1,147,2,55,6,223,35,43,17,147,2,0,0,43,234,173,223,171,255,245,255,254,255,255,254,255,239,245,170,160],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [211,0,4,124,2,217,1,114,2,99,6,147,35,98,17,122,2,0,0,43,234,170,239,213,255,250,255,255,127,255,255,127,247,250,254],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [211,0,4,161,2,178,1,161,2,57,6,217,35,46,17,163,2,0,0,43,234,174,223,171,255,245,255,254,255,255,254,255,239,245,190],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [211,0,4,164,2,175,1,162,2,56,6,176,35,78,17,163,2,0,0,43,234,171,111,213,255,250,255,255,127,255,255,127,247,250,239],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [211,0,4,147,2,188,1,134,2,76,6,160,35,99,17,152,2,0,0,43,234,173,111,213,255,250,255,255,127,255,255,127,247,250,215,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_LOW",
			command: [211,0,4,159,2,172,1,165,2,53,6,178,35,77,17,168,2,0,0,43,234,170,183,234,255,253,127,255,191,255,255,191,251,253,123,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_LOW",
			command: [211,0,4,158,2,172,1,165,2,56,6,169,35,96,17,167,2,0,0,43,234,175,95,171,255,245,255,254,255,255,254,255,255,246,220],
		},
		//////////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [211,0,4,167,2,168,1,168,2,56,6,196,35,54,17,150,2,0,0,43,234,175,127,87,255,247,255,251,255,255,251,255,191,214,244],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [211,0,4,154,2,183,1,161,2,58,6,162,35,104,17,128,2,0,0,43,234,171,191,171,255,251,255,253,255,255,253,255,255,238,232],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [211,0,4,154,2,180,1,158,2,60,6,155,35,101,17,128,2,0,0,43,234,173,191,171,255,251,255,253,255,255,253,255,255,237,116],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [211,0,4,156,2,174,1,165,2,54,6,167,35,94,17,149,2,0,0,43,234,170,223,213,255,253,255,254,255,255,254,255,255,247,180],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [211,0,4,135,2,191,1,165,2,55,6,161,35,105,17,131,2,0,0,43,234,174,191,171,255,251,255,253,255,255,253,255,255,237,180],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [211,0,4,129,2,199,1,150,2,67,6,165,35,102,17,118,2,0,0,43,234,171,95,213,255,253,255,254,255,255,254,255,255,247,90],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [211,0,4,106,2,220,1,130,2,85,6,159,35,81,17,105,2,0,0,43,234,173,95,213,255,253,255,254,255,255,254,255,255,246,173],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [211,0,4,164,2,171,1,160,2,52,6,147,35,97,17,151,2,0,0,43,234,170,175,234,255,254,255,255,127,255,255,127,255,251,234],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [211,0,4,157,2,175,1,158,2,54,6,160,35,109,17,146,2,0,0,43,234,175,191,87,255,247,255,251,255,255,251,255,255,219,168],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [211,0,4,151,2,175,1,155,2,58,6,221,35,47,17,147,2,0,0,43,234,171,223,171,255,251,255,253,255,255,253,255,255,238,212],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [211,0,4,116,2,212,1,121,2,89,6,148,35,95,17,106,2,0,0,43,234,173,223,171,255,251,255,253,255,255,253,255,255,237,106],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [211,0,4,159,2,180,1,150,2,58,6,204,35,51,17,147,2,0,0,43,234,170,239,213,255,253,255,254,255,255,254,255,255,247,170],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [211,0,4,91,2,234,1,97,2,111,6,160,35,99,17,93,2,0,0,43,234,174,223,171,255,251,255,253,255,255,253,255,255,237,170],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [211,0,4,159,2,179,1,137,2,69,6,154,35,109,17,130,2,0,0,43,234,171,111,213,255,253,255,254,255,255,254,255,255,247,85],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [211,0,4,152,2,180,1,144,2,60,6,222,35,33,17,144,2,0,0,43,234,173,111,213,255,253,255,254,255,255,254,255,255,246,170,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_MID",
			command: [211,0,4,167,2,173,1,165,2,56,6,224,35,49,17,168,2,0,0,43,234,170,183,234,255,254,255,255,127,255,255,127,255,251,248],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_MID",
			command: [211,0,4,161,2,176,1,165,2,57,6,205,35,62,17,164,2,0,0,43,234,175,95,171,255,251,255,253,255,255,253,255,255,237,240],
		},
		//////////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,122,2,202,1,134,2,76,6,149,35,103,17,166,2,0,0,43,234,175,127,87,255,239,255,251,255,255,251,255,191,214,214],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,150,2,176,1,146,2,63,6,161,35,104,17,170,2,0,0,43,234,171,191,171,255,247,255,253,255,255,253,255,223,235,171],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,151,2,173,1,150,2,55,6,203,35,62,17,166,2,0,0,43,234,173,191,171,255,247,255,253,255,255,253,255,223,235,85,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,166,2,172,1,162,2,55,6,174,35,87,17,149,2,0,0,43,234,170,223,213,255,251,255,254,255,255,254,255,239,245,250],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,159,2,177,1,160,2,55,6,158,35,108,17,137,2,0,0,43,234,174,191,171,255,247,255,253,255,255,253,255,223,235,122],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,161,2,174,1,163,2,54,6,158,35,96,17,151,2,0,0,43,234,171,95,213,255,251,255,254,255,255,254,255,239,245,221],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,160,2,173,1,161,2,55,6,185,35,68,17,154,2,0,0,43,234,173,95,213,255,251,255,254,255,255,254,255,239,245,174,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,110,2,216,1,123,2,100,6,158,35,84,17,94,2,0,0,43,234,170,175,234,255,253,255,255,127,255,255,127,247,250,246,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,152,2,171,1,168,2,56,6,179,35,92,17,151,2,0,0,43,234,175,191,87,255,239,255,251,255,255,251,255,191,214,218],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,149,2,180,1,158,2,57,6,170,35,98,17,141,2,0,0,43,234,171,223,171,255,247,255,253,255,255,253,255,223,235,173],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,106,2,225,1,113,2,98,6,153,35,101,17,96,2,0,0,43,234,173,223,171,255,247,255,253,255,255,253,255,223,235,86,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,147,2,190,1,129,2,80,6,153,35,99,17,115,2,0,0,43,234,170,239,213,255,251,255,254,255,255,254,255,239,245,245],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,160,2,172,1,157,2,54,6,160,35,65,17,149,2,0,0,43,234,174,223,171,255,247,255,253,255,255,253,255,223,235,117],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,149,2,180,1,148,2,62,6,148,35,108,17,133,2,0,0,43,234,171,111,213,255,251,255,254,255,255,254,255,239,245,218,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,134,2,192,1,140,2,72,6,159,35,108,17,122,2,0,0,43,234,173,111,213,255,251,255,254,255,255,254,255,239,245,173,64],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_31",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,169,2,170,1,153,2,54,6,210,35,85,17,149,2,0,0,43,234,170,183,234,255,253,255,255,127,255,255,127,247,250,245,64],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_32",
			fan: "AC_FAN_HIGH",
			command: [211,0,4,131,2,195,1,130,2,77,6,155,35,101,17,127,2,0,0,43,234,175,95,171,255,247,255,253,255,255,253,255,255,237,170],
		},
	]
}

export default PLASMA_STREAM_YKR_K_002E